import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgCloseThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "motorway-svg-fill",
    d: "M20.365 4.809l-1.06-1.061-7.249 7.248L4.81 3.748l-1.061 1.06 7.248 7.248-7.248 7.248 1.06 1.06 7.248-7.247 7.248 7.248 1.06-1.06-7.247-7.249 7.248-7.247z",
    fill: "#1D1D1B",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}

export { SvgCloseThin as S };
